import React from 'react'
import style from './reactjs.module.css'
import ContactUs from '../../components/contactus/ContactUs'
import HireDevlopers from '../../components/hiredevlopers/HireDevlopers'
import hiredevlopersimage from '../../assets/reactjs/reactjs1.png'
import ReactjsServices from '../../components/services/reactjs/ReactjsServices'
import HireReactJs from '../../components/hiredevloperway/reactjs/HireReactJs'
import ReactJsWorkFlow from '../../components/workflow/reactjs/ReactJsWorkFlow'

const ReactJs = () => {
    return (
        <>
            <div className={`${style.maindiv}`}>
                <div className={`row ${style.rowpadding}`}>
                    <div className="col-lg-6 col-12 pe-3 position-relative">
                        <div className={style.wordgroup}>
                            <span className={style.software}>Hire </span>
                            <span className={style.development}>ReactJS </span>
                            <span className={style.company}> Developers  </span>
                            <div className='mt-xl-4 mt-sm-3 mt-1'>
                                <p className={style.content}>Hire ReactJs Developers that utilize the full potential of the JavaScript library to build the most efficient, visually stunning, dynamic, flexible, and user-interactive web applications. We use industry-leading tools and technologies like ES6, Redux, JSX, TypeScript, and many more to provide different types of React Js development services like single-page applications, e-commerce platforms, web app maintenance, and many more.</p>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-6 col-12 ps-xl-5 mt-md-0 mt-3">
                        <HireDevlopers />
                    </div>
                </div>
                <div className={`${style.rowpadding}`}>
                    <div className={`${style.heading} ${style.headingborder}`}>
                        Hire the Top 1% of Reactjs Developers
                    </div>
                    <div className="row mt-xl-5 mt-4">
                        <div className="col-lg-5 col-12 d-xl-inline d-flex justify-content-center">
                            <img src={hiredevlopersimage} alt="" className={style.reactjsimage} />
                        </div>
                        <div className="col-lg-7 col-12 p-xl-5 mt-md-0 mt-3 px-sm-2 d-flex flex-column justify-content-center">
                            <div className={style.content}>
                                Want to build fully functional and high-performing web applications? Then get our top 1% remote ReactJs developers who are known for using a combination of frameworks like NPM, Socket.io, Rest, etc. to create high-performing solutions for the clients to solve real-world problems.
                            </div>
                            <div className={`mt-4 ${style.content}`}>
                                <span className={style.spancontent}> Hire dedicated ReactJs developers</span> from Brain Binary Infotech who have hands-on experience in UI designing and many front-end technologies. They utilize various programming languages like ReactJs, HTML, CSS, Json-API, and many more to deliver modern solutions to stay one step ahead of the competitors.
                            </div>
                        </div>
                    </div>
                </div>
                <ReactjsServices />
                <ReactJsWorkFlow />
                <HireReactJs />
                <ContactUs />
            </div >
        </>
    )
}

export default ReactJs